import * as actionTypes from "./actionTypes";

export const investMagicResearch = (govId?: number, isOwner?: boolean) => ({
  type: actionTypes.INVEST_MAGIC_RESEARCH,
  govId,
  isOwner
});

export const learnSpell = (spellId: number, govId?: number, isOwner?: boolean) => ({
  type: actionTypes.LEARN_SPELL,
  spellId,
  govId,
  isOwner
});

export const upgradeSpell = (familyId: number, govId?: number, isOwner?: boolean) => ({
  type: actionTypes.UPGRADE_SPELL,
  familyId,
  govId,
  isOwner
});

export const disperseSpell = (spellId: number, govId?: number, isOwner?: boolean) => ({
  type: actionTypes.DISPERSE_SPELL,
  spellId,
  govId,
  isOwner
});

export const castSpell = (spellId: number, govId?: number, isOwner?: boolean) => ({
  type: actionTypes.CAST_SPELL,
  spellId,
  govId,
  isOwner
});

export const setAutocast = (spellId: number) => ({
  type: actionTypes.SET_AUTOCAST,
  spellId
});

export const planSpell = ({
  spellId,
  targetId,
  level,
  spellOn,
  emperorTent,
  sender,
  isOwner
}: any) => ({
  type: actionTypes.PLAN_SPELL,
  spellId,
  targetId,
  level,
  spellOn,
  emperorTent,
  sender,
  isOwner
});

export const updateSpell = ({
  spellTableId,
  upType,
  upValue,
  emperorTent,
  sender,
  isOwner
}: any) => ({
  type: actionTypes.UPDATE_SPELL,
  spellTableId,
  upType,
  upValue,
  emperorTent,
  sender,
  isOwner
});

export const toggleMagicPlan = (
  close: number,
  emperorTent: number,
  govId?: number,
  isOwner?: boolean
) => ({
  type: actionTypes.TOGGLE_MAGIC_PLAN,
  close,
  emperorTent,
  govId,
  isOwner
});

export const setMagicMode = (
  newMagicMode: number,
  govId?: number,
  isOwner?: boolean
) => ({
  type: actionTypes.SET_MAGIC_MODE,
  newMagicMode,
  govId,
  isOwner
});
